export default __webpack_public_path__ + "static/media/memeMuseum.af61e864.jpg";